module.exports = __webpack_public_path__ + "static/media/IstokWeb-Regular.298ea385.ttf";